module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-dashboard-guide"
  }, [_c('img', {
    staticClass: "lxm-dashboard-guide__bell",
    attrs: {
      "src": require("../../../images/main/bell.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lxm-dashboard-guide__title"
  }, [_vm._v("\n    还没有新鲜事哦，快去电脑端灵析发起筹款吧！\n  ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c9472a2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c9472a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Dashboard/components/Guide.vue
// module id = 823
// module chunks = 0